import axios from 'axios';

export function uploadReceipt(file) {
    const data = new FormData();
    data.append('receipt', file);
    return axios.post('/api/receipts', data);
}
